import { ApimInterceptor } from './interceptors/apim.interceptor';
import { ErrorHandlerModule } from './errors/error-handler.module';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { OperationLogInterceptor } from './interceptors/operation-log.interceptor';

@NgModule({
  declarations: [],
  imports: [
    ErrorHandlerModule
  ],
  exports: [
    ErrorHandlerModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor, multi: true
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: OperationLogInterceptor, multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApimInterceptor, multi: true
    }
  ]
})
export class CoreModule { }
